if (window.BSS_BCP?.addAction) {
    BSS_BCP.addAction("custom_show_r4q", function ({ applyCartPage, quoteConfig, translations, shopData }) {
        document.addEventListener("DOMContentLoaded", function () {
            const cartDrawerElement = document.querySelector("cart-drawer");
            const cartDrawerObserver = new MutationObserver(function (mutations, observer) {
                if (mutations.some((item) => (item.type === "attributes") && (item.attributeName === "class") && item.target.classList.contains("active"))) {
                    cartDrawerElement.querySelectorAll(".bss-b2b-customer-portal-btn-quote-default").forEach((item) => item.remove());
                    applyCartPage(shopData, window.BSS_BCP, quoteConfig, translations);
                }
            });
            if (cartDrawerElement) cartDrawerObserver.observe(cartDrawerElement, { attributes: true });
        });
    });
}